export default {
  // for app header component
  'appHeader.verantosLogo.alt': 'Verantos',
  // TODO: cleanup with cp_app_header_rename ff — the container falls back to this key
  // while the flag is off; drop once the flag is fully rolled out (AppHeader.spec.tsx's
  // generic component tests also reference it — check before removing).
  'appHeader.platform.name': 'Evidence Platform',
  'appHeader.platform.name.curation': 'Curation Platform',
  'appHeader.userMenu.accountSettings': 'Account',
  'appHeader.userMenu.helpSupport': 'Help & support',
  'appHeader.userMenu.logout': 'Log out',

  // app header accout dialog
  'appHeader.accountDialog.title': 'Account',
  'appHeader.accountDialog.label.fullName': 'Full name',
  'appHeader.accountDialog.label.email': 'Email address',
  'appHeader.accountDialog.label.roles': 'Role(s)',
  'appHeader.accountDialog.label.organization': 'Organization',

  'appHeader.accountDialog.label.resetPassword': 'Reset password',

  // confirm dialog
  'appHeader.confirmLogoutDialog.title': 'Log out',
  'appHeader.confirmLogoutDialog.message.title': 'Confirm log out',
  'appHeader.confirmLogoutDialog.message':
    'Logging out will end your session. Any unsaved changes will be lost.',
  'appHeader.confirmLogoutDialog.cancelButton.label': 'Cancel',
  'appHeader.confirmLogoutDialog.saveButton.label': 'Log out',

  // app header feature section titles
  // TODO: cleanup with cp_app_header_rename ff — only consumed by the container's
  // pre-flag getSectionName() branch; remove this key once the flag is fully rolled out.
  'appHeader.applicationName': 'Annotation Workspace',
  'appHeader.feature.sectionTitle.annotator-queue': 'Annotator Workspace',
  'appHeader.feature.sectionTitle.annotation-dashboard': 'Annotation Dashboard',
  'appHeader.feature.sectionTitle.annotation-supervisor': 'Supervisor Workspace',
  'appHeader.feature.sectionTitle.admin-projects': 'Manage Projects',
};
